import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

interface Step {
  key: string;
  tag: string;
  title: string;
  description: string;
  icon: string;
  image: string;
  highlights: string[];
}

@Component({
  selector: 'app-how-it-works-section',
  templateUrl: './how-it-works-section.component.html',
  styleUrl: './how-it-works-section.component.scss',
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class HowItWorksSectionComponent implements OnInit, OnDestroy {
  active = signal(0);
  private timer: ReturnType<typeof setInterval> | null = null;

  steps: Step[] = [
    {
      key: 'reserve',
      tag: '01 · Reserve',
      title: 'Book the room, pick the people.',
      description:
        'Pick a time, invite your team, reserve a physical room or a virtual space — all from a single calendar view that respects every timezone.',
      icon: 'event_available',
      image: 'assets/images/artboard2.png',
      highlights: ['Two-way calendar sync', 'Conflict-free rooms', 'Timezone-smart invites'],
    },
    {
      key: 'host',
      tag: '02 · Host',
      title: 'Meet in HD. Low bandwidth friendly.',
      description:
        'Join on web or mobile with a single tap. Lossless audio, adaptive video, instant screen share — tuned for networks across every region.',
      icon: 'videocam',
      image: 'assets/images/artboard1.png',
      highlights: ['Up to 500 attendees', 'Adaptive video', 'One-tap record'],
    },
    {
      key: 'capture',
      tag: '03 · Capture',
      title: 'Decisions, minutes, action items — automatic.',
      description:
        'Every meeting is transcribed, summarised, and tagged. Share minutes in a click. Nothing important ever slips through the cracks again.',
      icon: 'record_voice_over',
      image: 'assets/images/artboard3.png',
      highlights: ['Auto-transcription', 'Smart minutes', 'Action tracking'],
    },
    {
      key: 'report',
      tag: '04 · Report',
      title: 'Leadership sees everything that matters.',
      description:
        'Attendance, duration, participation, outcomes — delivered to the people who need them, on the dashboards they already use.',
      icon: 'insights',
      image: 'assets/images/artboard2.png',
      highlights: ['Live dashboards', 'Exportable reports', 'Role-based access'],
    },
  ];

  ngOnInit(): void {
    this.timer = setInterval(() => {
      this.active.update(i => (i + 1) % this.steps.length);
    }, 6000);
  }

  ngOnDestroy(): void {
    if (this.timer) clearInterval(this.timer);
  }

  select(i: number) {
    this.active.set(i);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.active.update(idx => (idx + 1) % this.steps.length);
      }, 6000);
    }
  }
}
